import { api } from "@/lib/api";

export const fmtGB = (n) => (n == null ? "—" : `${(n / 1024 ** 3).toFixed(1)} GB`);

export const fmtAgo = (iso) => {
  if (!iso) return "never";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", {
  day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit",
}) : "—");

export const keyLabel = (k) => {
  try { return JSON.parse(k).$oid?.slice(-8) || k; } catch { return k; }
};

// Ask the shop server to restart (applies a new storage folder) and wait until it answers again.
export async function restartAndWait() {
  await api.post("/local/restart");
  await new Promise(r => setTimeout(r, 4000));
  for (let i = 0; i < 45; i++) {
    try { await api.get("/local/public-status", { timeout: 2000 }); return true; } catch { await new Promise(r => setTimeout(r, 2000)); }
  }
  return false;
}
